/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Card, Grid, LinearProgress } from '@mui/material';
import { CardList, DialogForm, ICardActions, ICardColumns, IChipFilter, IChipsSettingProps, IDialogActions, IKanbanCardColumns, ISnackbarAlert, ISwitchInputProps, KanbanList, SelectField, SnackbarAlert, TextFieldInput, ToolBar } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { useTheme } from '@mui/material/styles';
import { AccessRoleDTO, AccessRoleFilterDTO, ResumeVacancyDTO, ResumeVacancyFilterDTO, ValueListDTO } from '../../../shared/interfaces';
import { ResumeMaintenance } from '../resume/ResumeMaintenance';
import { Interview } from '../interview/Inteview';
import { HistoricalStatusTimeLine } from '../../historicalsphere/historicalStatus/HistoricalStatusTimeLine';
import { CustomResume } from './CustomResume';
import { MinimalResumeMaintenance } from '../resume/MinimalResumeMaintenance';
import { Comment } from '../../infosphere/comment/Comment';
import { useTranslation } from 'react-i18next';

interface IResumeVacancyAssociateProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
    actionExecuted: boolean | false;
    isCustomer: boolean | false;
}

export const ResumeVacancyAssociate: React.FC<IResumeVacancyAssociateProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted, actionExecuted, isCustomer }) => {
    const [resumeVacancyDTO, setResumeVacancyDTO] = useState<ResumeVacancyDTO>();
    const [resumeVacancyFilterSelectedDTO, setResumeVacancyFilterSelectedDTO] = useState<ResumeVacancyFilterDTO>();
    const [resumeVacancyFilterAvailableDTO, setResumeVacancyFilterAvailableDTO] = useState<ResumeVacancyFilterDTO>();
    const [resumeListSelected, setResumeListSelected] = useState<ResumeVacancyDTO[]>([]);
    const [resumeListAvailable, setResumeListAvailable] = useState<ResumeVacancyDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);

    const [customerStatusList, setCustomerStatusList] = useState<ValueListDTO[]>([]);
    const [interview, setInterview] = useState('');
    const [historicalStatusTimeLine, setHistoricalStatusTimeline] = useState('');
    const [customResume, setCustomResume] = useState('');
    const [resumeInScreening, setResumeInScreening] = useState('');
    const [comment, setComment] = useState('');

    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');
    const [resumeSelect, setResumeSelect] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingSelected, setLoadingSelected] = useState(false);
    const [loadingAvailable, setLoadingAvailable] = useState(false);

    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenSnackBar] = useState(false);

    const [cardMoved, setCardMoved] = useState<any>();
    const [checkedKanban, setCheckedKanban] = useState(true);

    const [isOpenMaintenanceLocal, setIsOpenMaintenanceLocal] = useState(false);
    const theme = useTheme();

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    const getKanbanStatusList = useCallback(() => {
        const identifierField = isCustomer ? 'customerStatusId' : 'statusId';
        const currentStatusList = isCustomer ? customerStatusList : statusList;
        const statusIdsWithCards = new Set(resumeListSelected.map((resumeVacancy: any) => resumeVacancy[identifierField]).filter(Boolean));

        return [
            ...currentStatusList.filter((status) => statusIdsWithCards.has(status.id)),
            ...currentStatusList.filter((status) => !statusIdsWithCards.has(status.id)),
        ];
    }, [customerStatusList, isCustomer, resumeListSelected, statusList]);

    useEffect(() => {
        setResumeVacancyFilterSelectedDTO({
            ...resumeVacancyFilterSelectedDTO,
            resumeId: '',
            vacancyId: data.id,
            statusId: '',
            name: '',
            createdById: '',
            searchAssociated: true
        } as ResumeVacancyFilterDTO);

        setResumeVacancyFilterAvailableDTO({
            ...resumeVacancyFilterAvailableDTO,
            resumeId: '',
            vacancyId: data.id,
            statusId: '',
            name: '',
            searchAssociated: false
        } as ResumeVacancyFilterDTO);

        setResumeVacancyDTO({
            ...resumeVacancyDTO,
            resumeId: '',
            vacancyId: '',
            statusId: '',
            kanbanIndex: 0,
            customerStatusId: '',
            customerKanbanIndex: 0,
            createdById: ''
        } as ResumeVacancyDTO);
        handleListGetAll(ListId.talentsphere.resumeVacancy.statusId, setStatusList);
        handleListGetAll(ListId.talentsphere.resumeVacancy.customerStatusId, setCustomerStatusList);

        handleGetPermission(ListId.talentsphere.resumeVacancyId, setAccessRolePermissionDTO);
    }, [data]);

    useEffect(() => {
        handleResumeGetAllViewAsync(setResumeListSelected, setLoadingSelected, resumeVacancyFilterSelectedDTO);
    }, [resumeVacancyFilterSelectedDTO]);

    useEffect(() => {
        handleResumeGetAllViewAsync(setResumeListAvailable, setLoadingAvailable, resumeVacancyFilterAvailableDTO);
    }, [resumeVacancyFilterAvailableDTO]);

    useEffect(() => {
        if (actionExecuted) {
            handleResumeGetAllViewAsync(setResumeListSelected, setLoadingSelected, resumeVacancyFilterSelectedDTO);
            handleResumeGetAllViewAsync(setResumeListAvailable, setLoadingAvailable, resumeVacancyFilterAvailableDTO);
        }
    }, [actionExecuted]);

    useEffect(() => {
        handleMoveTaskKanbanAsync();
    }, [cardMoved]);

    useEffect(() => {
        setEditRecord('');
    }, [isOpenMaintenance]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList,);
    }, []);

    const handleMoveTaskKanbanAsync = useCallback(async () => {

        const identifierValue = isCustomer ? 'customerStatusId' : 'statusId';

        if (cardMoved === undefined || cardMoved.id === undefined || cardMoved[identifierValue] === undefined) {
            return;
        }
        const resumeId = cardMoved.id;
        const statusId = cardMoved[identifierValue];
        const index = cardMoved.index;

        const resumeVacancyDTO: any = {
            id: resumeId,
            vacancyId: data.id,
            updatedById: userInfo.user.Id
        };

        if (isCustomer) {
            resumeVacancyDTO.customerStatusId = statusId;
            resumeVacancyDTO.customerKanbanIndex = index;
        }
        else {
            resumeVacancyDTO.statusId = statusId;
            resumeVacancyDTO.kanbanIndex = index;
        }

        GenericService.PostGenericAsync1('talentsphere.resumeVacancy', 'MoveTaskKanbanAsync', resumeVacancyDTO, setActionExecuted, setLoading, showMessage);
    }, [cardMoved]);

    const handleResumeGetAllViewAsync = useCallback(async (setList: any, setLoading: any, filterDTO?: ResumeVacancyFilterDTO) => {
        if (filterDTO === undefined)
            return;

        GenericService.GetAllViewAsync1('talentsphere.ResumeVacancy', filterDTO, setActionExecuted, setLoading, setList, showMessage, true);
    }, [data]);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'valueindex, value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const HandleResumeAddAsync = useCallback(async (resumeVacancy: any) => {
        const dto: ResumeVacancyDTO = {
            vacancyId: data.id,
            resumeId: resumeVacancy.resumeId,
            statusId: ListId.talentsphere.resumeVacancy.statusStartId, //initial status
            customerStatusId: ListId.talentsphere.resumeVacancy.customerStatusStartId,
            customerKanbanIndex: 0,
            kanbanIndex: 0,
            matchPercentageMandatoryHardSkill: resumeVacancy.matchPercentageMandatoryHardSkill,
            matchPercentageOptionalHardSkill: resumeVacancy.matchPercentageOptionalHardSkill,
            matchPercentageMandatorySoftSkill: resumeVacancy.matchPercentageMandatorySoftSkill,
            matchPercentageOptionalSoftSkill: resumeVacancy.matchPercentageOptionalSoftSkill,
            matchPercentageMandatoryLanguage: resumeVacancy.matchPercentageMandatoryLanguage,
            matchPercentageOptionalLanguage: resumeVacancy.matchPercentageOptionalLanguage,
            createdById: userInfo.user.id
        };
        GenericService.AddAsync1('talentsphere.ResumeVacancy', dto, setResumeVacancyDTO, setActionExecuted, setLoading, showMessage);
    }, [data]);

    const handleDeleteClick = useCallback(async (resumeVacancy: any) => {
        const dto = {
            vacancyId: data.id,
            resumeId: resumeVacancy.resumeId,
            createdById: userInfo.user.id
        };
        GenericService.PostGenericAsync1('talentsphere.ResumeVacancy', 'DeleteByAsync', dto, setActionExecuted, setLoading, showMessage);
    }, [data]);

    const handleAssociateClick = (resumeVacancy: string) => {
        if (!accessRolePermissionDTO?.allowAdd) {
            showMessage(t('vacancy.resumeVacancyAssociate.message.handleAssociateClick'), 'info');
            return;
        }
        if (data.statusId != ListId.talentsphere.vacancy.status.inProgress) {
            showMessage(t('vacancy.resumeVacancyAssociate.message.statusId'), 'info');
            return;
        }
        HandleResumeAddAsync(resumeVacancy);
    };

    const handleDisassociate = (resumeVacancy: string) => {
        if (!accessRolePermissionDTO?.allowDelete) {
            showMessage(t('vacancy.resumeVacancyAssociate.message.accessRolePermissionDTO'), 'info');
            return;
        }
        handleDeleteClick(resumeVacancy);
    };

    const handleResumeSelect = () => {
        setResumeSelect(!resumeSelect);
    };

    const handleClearFilterSelectedClick = () => {
        setResumeVacancyFilterSelectedDTO({
            ...resumeVacancyFilterSelectedDTO,
            resumeId: '',
            vacancyId: data.id,
            name: '',
            createdById: '',
            searchAssociated: true
        } as ResumeVacancyFilterDTO);
    };

    const handleSearchSelectedClick = () => {
        handleResumeGetAllViewAsync(setResumeListSelected, setLoadingSelected, resumeVacancyFilterSelectedDTO);
    };

    const handleClearFilterAvailableClick = () => {
        setResumeVacancyFilterSelectedDTO({
            ...resumeVacancyFilterSelectedDTO,
            resumeId: '',
            vacancyId: data.id,
            name: '',
            createdById: '',
            statusId: '',
            searchAssociated: true
        } as ResumeVacancyFilterDTO);
    };

    const handleSearchAvailableClick = () => {
        handleResumeGetAllViewAsync(setResumeListSelected, setLoadingAvailable, resumeVacancyFilterSelectedDTO);
    };

    const handleViewDetatils = (data: string) => {
        setEditRecord(data);
        setInterview('');
        setHistoricalStatusTimeline('');
        setCustomResume('');
        setResumeInScreening('');
        setComment('');
        setIsOpenMaintenanceLocal(true);
    };

    const handleInterview = (data: any) => {
        setEditRecord('');
        setInterview(data.resumeId);
        setHistoricalStatusTimeline('');
        setCustomResume('');
        setResumeInScreening('');
        setComment('');
        setIsOpenMaintenanceLocal(true);
    };

    const handleHistoricalTimeLine = (data: any) => {
        setEditRecord('');
        setInterview('');
        setHistoricalStatusTimeline(data.id);
        setCustomResume('');
        setResumeInScreening('');
        setComment('');
        setIsOpenMaintenanceLocal(true);
    };

    const handleCustomResume = (data: string) => {
        setEditRecord('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setCustomResume(data);
        setResumeInScreening('');
        setComment('');
        setIsOpenMaintenanceLocal(true);
    };

    const handleResumeInScreening = () => {
        setEditRecord('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setCustomResume('');
        setResumeInScreening(data);
        setComment('');
        setIsOpenMaintenanceLocal(true);
    };

    const handleComment = (data: any) => {
        setEditRecord('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setCustomResume('');
        setResumeInScreening('');
        setComment(data.resumeId);
        setIsOpenMaintenanceLocal(true);
    };

    const resumeSelectText = resumeSelect ? t('vacancy.resumeVacancyAssociate.resumeSelectText.resumeSelectClose') : t('vacancy.resumeVacancyAssociate.resumeSelectText.resumeSelect');
    const resumeSelectColor = resumeSelect ? 'warning' : 'info';

    const actions: IDialogActions[] = [
        { id: 'resumeSelect', text: resumeSelectText, icon: 'how_to_reg_outlined', iconColor: resumeSelectColor, setAction: handleResumeSelect, isClose: false },
        { id: 'close', text: t('vacancy.resumeVacancyAssociate.dialogActions.close'), icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    //selected
    const chipResumeVacancyStatus: IChipsSettingProps[] = [
        { value: 'Competing for the Vacancy', iconName: 'person_add_alt_outlined', iconColor: 'primary' },
        { value: 'Interview Schedule with HR', iconName: 'manage_accounts_outlined', iconColor: 'info' },
        { value: 'Scheduled Interview with Technical Area', iconName: 'manage_accounts_outlined', iconColor: 'info' },
        { value: 'Under Analysis by the Customer', iconName: 'manage_accounts_outlined', iconColor: 'warning' },
        { value: 'Approved by Customer', iconName: 'person_outlined', iconColor: 'warning' },
        { value: 'Offer Letter Sent', iconName: 'person_outlined', iconColor: 'info' },
        { value: 'Accepted Offer Letter', iconName: 'person_outlined', iconColor: 'success' },
        { value: 'Offer Letter rejected', iconName: 'person_off_outlined', iconColor: 'error' },
        { value: 'Disapproved by HR', iconName: 'person_off_outlined', iconColor: 'error' },
        { value: 'Disapproved by the Technical Area', iconName: 'person_off_outlined', iconColor: 'error' },
        { value: 'Disapproved by the Customer', iconName: 'person_off_outlined', iconColor: 'warning' },
        { value: 'Dispensed', iconName: 'person_off_outlined', iconColor: 'warning' },
    ];

    const chipCustomerStatus: IChipsSettingProps[] = [
        { value: 'In Screening', iconName: 'pending_outlined', iconColor: 'primary' },
        { value: 'Interview 1 Scheduled', iconName: 'manage_accounts_outlined', iconColor: 'info' },
        { value: 'Interview 2 Scheduled', iconName: 'manage_accounts_outlined', iconColor: 'info' },
        { value: 'Interview 3 Scheduled', iconName: 'manage_accounts_outlined', iconColor: 'info' },
        { value: 'Pre Approved', iconName: 'person_add_alt_outlined', iconColor: 'warning' },
        { value: 'Approved', iconName: 'person_outlined', iconColor: 'success' },
        { value: 'Repproved', iconName: 'person_off_outlined', iconColor: 'error' },
        { value: 'Dispensed', iconName: 'person_off_outlined', iconColor: 'error' },
    ];

    const columnsSelected: ICardColumns[] = [
        { field: 'code', label: 'Code', size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'name', label: 'Resume', size: 4, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'jobTitle', label: 'Job Title', size: 4, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'seniority', label: 'Seniority', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'email', label: 'Email', size: 6, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'status', label: 'Status', size: 4, type: 'text', visible: true, isChip: true, chipSettings: chipResumeVacancyStatus, hasFieldLine: false, hasToolTip: true },
        { field: 'customerStatus', label: 'Interview Status of Customer', size: 2, type: 'text', visible: true, isChip: true, chipSettings: chipCustomerStatus, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageMandatoryHardSkill', label: 'Hardskill Match % Required', size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageOptionalHardSkill', label: 'Hardskill Match % Optional', size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageMandatorySoftSkill', label: 'Softskill Match % Mandatory', size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageOptionalSoftSkill', label: 'Softskill Match % Optional', size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageMandatoryLanguage', label: 'Language Match % Mandatory', size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageOptionalLanguage', label: 'Language Match % Optional', size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
    ];

    const cardActionsSelected: ICardActions[] = [
        { id: 'viewDetails', toolTip: 'View Details', icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'interview', toolTip: 'Interview', icon: 'voice_chat_outlined', iconColor: 'success', setAction: handleInterview },
        { id: 'comments', toolTip: 'Comments', icon: 'comment_outlined', iconColor: 'success', setAction: handleComment },
        { id: 'timeline', toolTip: 'Timeline', icon: 'timeline_outlined', iconColor: 'success', setAction: handleHistoricalTimeLine },
        { id: 'customResume', toolTip: 'Custom Resume', icon: 'summarize_outlined', iconColor: 'info', setAction: handleCustomResume },
        { id: 'disassociate', toolTip: 'Disassociate', icon: 'delete_outlined', iconColor: 'error', setAction: handleDisassociate },
    ];

    const chipFiltersSelected: IChipFilter[] = [
        { label: 'Total Records', value: resumeListSelected.length },
        { label: 'Name', value: resumeVacancyFilterSelectedDTO?.name },
    ];

    const toolBarActionsSelected: IDialogActions[] = [
        { id: 'new', text: t('vacancy.resumeVacancyAssociate.toolBarActionsSelected.addResumeForScreening'), icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleResumeInScreening },
    ];

    //available
    const chipResumeStatus: IChipsSettingProps[] = [
        { value: t('vacancy.resumeVacancyAssociate.chipResumeStatus.active'), iconName: 'person_add_alt_outlined', iconColor: 'success' },
        { value: t('vacancy.resumeVacancyAssociate.chipResumeStatus.inactive'), iconName: 'person_add_disabled_outlined', iconColor: 'error' },
        { value: t('vacancy.resumeVacancyAssociate.chipResumeStatus.hired'), iconName: 'person_outlined', iconColor: 'warning' },
        { value: t('vacancy.resumeVacancyAssociate.chipResumeStatus.competingForTheVacancy'), iconName: 'manage_accounts_outlined', iconColor: 'info' },
    ];

    const columnsAvailable: ICardColumns[] = [
        { field: 'code', label: t('vacancy.resumeVacancyAssociate.cardColumns.code'), size: 2, type: t('vacancy.resumeVacancyAssociate.cardColumns.text'), visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'name', label: t('vacancy.resumeVacancyAssociate.cardColumns.resume'), size: 6, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'jobTitle', label: t('vacancy.resumeVacancyAssociate.cardColumns.jobTitle'), size: 4, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'seniority', label: t('vacancy.resumeVacancyAssociate.cardColumns.seniority'), size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'email', label: t('vacancy.resumeVacancyAssociate.cardColumns.email'), size: 6, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'status', label: t('vacancy.resumeVacancyAssociate.cardColumns.status'), size: 4, type: 'text', visible: true, isChip: true, chipSettings: chipResumeStatus, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageMandatoryHardSkill', label: t('vacancy.resumeVacancyAssociate.cardColumns.hardskillMatch%Required'), size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageOptionalHardSkill', label: t('vacancy.resumeVacancyAssociate.cardColumns.hardskillMatch%Optional'), size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageMandatorySoftSkill', label: t('vacancy.resumeVacancyAssociate.cardColumns.softskillMatch%Mandatory'), size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageOptionalSoftSkill', label: t('vacancy.resumeVacancyAssociate.cardColumns.softskillMatch%Optional'), size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageMandatoryLanguage', label: t('vacancy.resumeVacancyAssociate.cardColumns.languageMatch%Mandatory'), size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'matchPercentageOptionalLanguage', label: t('vacancy.resumeVacancyAssociate.cardColumns.languageMatch%Optional'), size: 2, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
    ];

    const cardActionsAvailable: ICardActions[] = [
        { id: 'viewDetails', toolTip: t('vacancy.resumeVacancyAssociate.cardActionsAvailable.viewDetails'), icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'associate', toolTip: t('vacancy.resumeVacancyAssociate.cardActionsAvailable.associate'), icon: 'add_circle_outlined', iconColor: 'success', setAction: handleAssociateClick },
    ];

    const chipFiltersAvailable: IChipFilter[] = [
        { label: t('vacancy.resumeVacancyAssociate.chipFiltersAvailable.totalRecords'), value: resumeListSelected.length },
        { label: t('vacancy.resumeVacancyAssociate.chipFiltersAvailable.name'), value: resumeVacancyFilterSelectedDTO?.name },
    ];

    const toolBarActionsAvailable: IDialogActions[] = [
        // { id: 'new', text: 'New Resume', icon: 'add_circle_outlined', iconColor: 'primary', setAction: () => void undefined },
    ];

    //kanban
    const kanbanSwitch: ISwitchInputProps = {
        id: 'vacancy.switch', label: t('vacancy.resumeVacancyAssociate.switchInputProps.KanbanOrList'), checked: checkedKanban, setChecked: setCheckedKanban, disabled: false, autoFocus: false, color: 'info', size: 'small', labelPlacement: 'end'
    };

    const kanbanColumns: IKanbanCardColumns[] = [
        { field: 'code', label: t('vacancy.resumeVacancyAssociate.kanbanCardColumns.code'), size: 12, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'name', label: t('vacancy.resumeVacancyAssociate.kanbanCardColumns.resume'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'recruiter', label: t('vacancy.resumeVacancyAssociate.kanbanCardColumns.recruiter'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        // { field: 'seniority', label: 'Seniority', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        // { field: 'resumeStatus', label: 'Resume Status', size: 12, type: 'text', visible: true, isChip: true, chipSettings: chipResumeStatus, hasFieldLine: false, hasToolTip: true },
        // { field: 'experienceTime', label: 'Experience', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        // { field: 'matchPercentageMandatoryHardSkill', label: 'Hardskill Match % Required', size: 12, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        // { field: 'matchPercentageOptionalHardSkill', label: 'Hardskill Match % Optional', size: 12, type: 'percent', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
    ];

    const cardActions: ICardActions[] = [
        { id: 'viewDetails', toolTip: t('vacancy.resumeVacancyAssociate.cardActions.viewDetails'), icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'comments', toolTip: t('vacancy.resumeVacancyAssociate.cardActions.comments'), icon: 'comment_outlined', iconColor: 'success', setAction: handleComment },
        // { id: 'interview', toolTip: t('vacancy.resumeVacancyAssociate.cardActions.interview'), icon: 'speaker_notes_outlined', iconColor: 'success', setAction: handleInterview },
        { id: 'timeline', toolTip: t('vacancy.resumeVacancyAssociate.cardActions.timeline'), icon: 'timeline_outlined', iconColor: 'success', setAction: handleHistoricalTimeLine },
        { id: 'customResume', toolTip: t('vacancy.resumeVacancyAssociate.cardActions.customResume'), icon: 'summarize_outlined', iconColor: 'info', setAction: handleCustomResume },
        { id: 'disassociate', toolTip: t('vacancy.resumeVacancyAssociate.cardActions.disassociate'), icon: 'delete_outlined', iconColor: 'error', setAction: handleDisassociate },

    ];

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={`${t('vacancy.resumeVacancyAssociate.dialogForm.title')} ${data.company} ${data.code} ${data.jobtTitle} ${data.seniority}`}
                icon='compare_arrows_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={false}
                paperSx={{ width: '96vw', height: '96vh', maxWidth: '96vw' }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, width: '100%' }}>
                    <Grid container spacing={2} sx={{ height: '100%', minHeight: 0 }}>
                        <Grid item xs={12} md={resumeSelect ? 6 : 12} sx={{ display: 'flex', height: '100%', minHeight: 0 }}>
                            <Card sx={{ display: 'flex', flexDirection: 'column', bgcolor: theme.palette.background.default, p: 1, height: '100%', maxHeight: '100%', minHeight: 0, overflow: 'hidden', width: '100%' }}>
                                <ToolBar
                                    clickSearch={handleSearchSelectedClick}
                                    clickClearFilter={handleClearFilterSelectedClick}
                                    chipFilters={chipFiltersSelected}
                                    actions={toolBarActionsSelected}
                                    kanbanSwitch={kanbanSwitch}
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='name'
                                                label={t('vacancy.resumeVacancyAssociate.textFieldInput.name')}
                                                setValue={setResumeVacancyFilterSelectedDTO}
                                                value={resumeVacancyFilterSelectedDTO?.name}
                                                obj={resumeVacancyFilterSelectedDTO}
                                                placeholder={t('vacancy.resumeVacancyAssociate.textFieldInput.resume')}
                                                maxLength={200}
                                            />
                                        </Grid>
                                    </Grid>
                                </ToolBar>
                                {loadingSelected && (
                                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                                )}
                                {checkedKanban ? (
                                    <Box sx={{ display: 'flex', flex: 1, minHeight: 0, width: '100%', overflow: 'hidden' }}>
                                        <KanbanList
                                            identifierField={isCustomer ? 'customerStatusId' : 'statusId'}
                                            cards={resumeListSelected}
                                            attributes={kanbanColumns}
                                            statusList={getKanbanStatusList()}
                                            setRowExpanded={() => void undefined}
                                            setCardMoved={setCardMoved}
                                            actions={cardActions}
                                            cardSize={2}
                                        />
                                    </Box>
                                ) : (
                                    <Box sx={{ display: 'flex', flex: 1, minHeight: 0, width: '100%', overflow: 'hidden' }}>
                                        <CardList
                                            columns={columnsSelected}
                                            rows={resumeListSelected}
                                            actions={cardActionsSelected}
                                            hasChildren={false}
                                            setRowExpanded={() => void undefined}
                                            cardSize={12}
                                            fillHeight={true}
                                            hidePagination={true}
                                        />
                                    </Box>
                                )}

                            </Card>
                        </Grid>

                        {resumeSelect && (
                            <Grid item xs={12} md={6} sx={{ display: 'flex', height: '100%', minHeight: 0 }}>
                                <Card sx={{ display: 'flex', flexDirection: 'column', bgcolor: theme.palette.background.default, p: 1, height: '100%', maxHeight: '100%', minHeight: 0, overflow: 'hidden', width: '100%' }}>
                                    <ToolBar
                                        clickSearch={handleSearchAvailableClick}
                                        clickClearFilter={handleClearFilterAvailableClick}
                                        chipFilters={chipFiltersAvailable}
                                        actions={toolBarActionsAvailable}
                                    >
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} md={12}>
                                                <TextFieldInput
                                                    id='name'
                                                    label={t('vacancy.resumeVacancyAssociate.textFieldInput.name')}
                                                    setValue={setResumeVacancyFilterAvailableDTO}
                                                    value={resumeVacancyFilterAvailableDTO?.name}
                                                    obj={resumeVacancyFilterAvailableDTO}
                                                    placeholder={t('vacancy.resumeVacancyAssociate.textFieldInput.name')}
                                                    maxLength={200}
                                                />
                                            </Grid>
                                        </Grid>
                                    </ToolBar>
                                    {loadingAvailable && (
                                        <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                                    )}
                                    <Box sx={{ display: 'flex', flex: 1, minHeight: 0, width: '100%', overflow: 'hidden' }}>
                                        <CardList
                                            columns={columnsAvailable}
                                            rows={resumeListAvailable}
                                            actions={cardActionsAvailable}
                                            hasChildren={false}
                                            setRowExpanded={() => void undefined}
                                            cardSize={12}
                                            fillHeight={true}
                                            hidePagination={true}
                                        />
                                    </Box>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                </Box>
            </DialogForm >
            {editRecord && (
                <ResumeMaintenance
                    data={editRecord}
                    setIsOpenMaintenance={setIsOpenMaintenanceLocal}
                    isOpenMaintenance={isOpenMaintenanceLocal}
                    setActionExecuted={setActionExecuted}
                />
            )}
            {interview && (
                <Interview
                    vacancyId={data.id}
                    resumeId={interview}
                    setIsOpenMaintenance={setIsOpenMaintenanceLocal}
                    isOpenMaintenance={isOpenMaintenanceLocal}
                    setActionExecuted={setActionExecuted}
                    actionExecuted={actionExecuted}
                />
            )}
            {historicalStatusTimeLine && (
                <HistoricalStatusTimeLine
                    title={t('vacancy.resumeVacancyAssociate.historicalStatusTimeLine.statusHistorical')}
                    ownerId={historicalStatusTimeLine}
                    setIsOpenMaintenance={setIsOpenMaintenanceLocal}
                    isOpenMaintenance={isOpenMaintenanceLocal}
                    setActionExecuted={setActionExecuted}
                    chipSettings={chipResumeVacancyStatus}
                />
            )}
            {customResume && (
                <CustomResume
                    data={customResume}
                    setIsOpenMaintenance={setIsOpenMaintenanceLocal}
                    isOpenMaintenance={isOpenMaintenanceLocal}
                    setActionExecuted={setActionExecuted}
                />
            )}
            {resumeInScreening && (
                <MinimalResumeMaintenance
                    data={resumeInScreening}
                    setIsOpenMaintenance={setIsOpenMaintenanceLocal}
                    isOpenMaintenance={isOpenMaintenanceLocal}
                    setActionExecuted={setActionExecuted}
                />
            )}
            {comment && (
                <Comment
                    ownerId={comment}
                    setIsOpenMaintenance={setIsOpenMaintenanceLocal}
                    isOpenMaintenance={isOpenMaintenanceLocal}
                    setActionExecuted={setActionExecuted}
                    actionExecuted={actionExecuted}
                />

            )}
        </React.Fragment >
    );
};
